import { render } from "./KeyWords.vue?vue&type=template&id=4c21f128&scoped=true&ts=true"
import script from "./KeyWords.vue?vue&type=script&lang=ts"
export * from "./KeyWords.vue?vue&type=script&lang=ts"

import "./KeyWords.vue?vue&type=style&index=0&id=4c21f128&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c21f128"]])

export default __exports__